module.exports = __webpack_public_path__ + "80a483b3786a0c6aade6e8be9939b1e6.png";